import styled from 'styled-components'

export const Wrapper = styled.div`
  span {
    color: #757575;
    border: 1px solid #D9D9D9;
    border-radius: 8px;
    padding: 4px;
    font-size: 12px;
    margin-left: 5px;
  }
`